import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getExchangeReceiptsBasedWarrantyType } from 'src/store/slices/generalMonitoringSlice';
import { getStatusItems } from 'src/store/slices/commonSlice';
import { BarList, ChartSkeleton, MonitorCard, MultiSelectFilter, formatNumber } from 'src/components/monitoring/MonitoringParts';

// Garanti tipine göre açık değişim fişleri (durum filtresi ile)
function ExchangeReceiptsBasedWarrantyTypesChart() {
  const dispatch = useDispatch();
  const statusData = useSelector((state) => state.commonSlice.statuses);
  const [mainData, setMainData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [selectedStatus, setStatus] = React.useState([]);

  const GetExchangeReceiptsBasedWarrantyType = (status) => {
    setLoading(true);
    dispatch(getExchangeReceiptsBasedWarrantyType(status))
      .then((response) => {
        setMainData(Array.isArray(response.payload) ? response.payload : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    dispatch(getStatusItems());
    GetExchangeReceiptsBasedWarrantyType('0');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Seçim boşsa tümü ('0')
  const handleSearchData = () => {
    const ids = (selectedStatus || []).map((row) => row.Id);
    GetExchangeReceiptsBasedWarrantyType(ids.length ? ids.toString() : '0');
  };

  const items = mainData.map((item) => ({ label: item.GARANTI_TIPI, value: item.TOPLAM_FIS_SAYISI }));
  const total = items.reduce((s, i) => s + (Number(i.value) || 0), 0);

  return (
    <MonitorCard
      title="Garanti Durumuna Göre Açık Fişler"
      subtitle={loading ? 'Yükleniyor…' : `Toplam ${formatNumber(total)} fiş`}
      action={
        <MultiSelectFilter
          label="Durum (tümü)"
          options={statusData}
          value={selectedStatus}
          onChange={setStatus}
          onApply={handleSearchData}
          disabled={loading}
        />
      }
    >
      {loading ? <ChartSkeleton height={240} /> : <BarList items={items} maxHeight={300} />}
    </MonitorCard>
  );
}

export default ExchangeReceiptsBasedWarrantyTypesChart;
